import './AiTopBar.css'
import React, {useContext} from "react";
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";

type AITopBarProps = {
    squares: string[]
}

// 游戏中倒计时
const AiTopBar: React.FC<AITopBarProps> = ({
                                               squares
                                           }) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <div className={`ai-top-bar-container`}>
            <div className="display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                <div className="position-relative width-27 height-27">
                    <img className="height-26 width-26 border-radius-round" src={imgUrls.aiTopBarAvatarUrl}
                         alt="ai"/>
                    <img className="width-10 height-10 position-absolute right-0 position-bottom-0"
                         src={imgUrls.greenPointIconUrl} alt="pic"/>
                </div>
                <div className="text-center my-roboto-medium font-size-16 margin-left-16 margin-right-12">AI</div>
                {
                    squares.map((bg, index) => {
                        return (
                            <div key={index} className="height-24 width-24 border-radius-6 margin-left-5"
                                 style={{
                                     backgroundImage: `url(${bg})`,
                                     backgroundSize: 'cover',
                                     backgroundPosition: "center"
                                 }}/>)
                    })
                }
            </div>
        </div>
    );
};
export default AiTopBar;